// The platform SPA's one place for the activity tracker.
//
// The tracker itself is page-runtime's (shared with the published site and the
// downloaded runtime); this only supplies what the platform knows: the collect
// URL under APP_BASE, and the bearer a page must send when its user is a
// project user or a signed-in site visitor rather than a Twasta account. The
// same SPA moves between the builder, the Run view and the site viewer, so a
// surface switch is a context change on the one tracker, not a second one.

import { APP_BASE } from '@/config/basePath'
import { installActivityTracker } from '@twasta/page-runtime/activity'
import type { ActivityTrackerConfig } from '@twasta/page-runtime/activity'

export interface HostActivityContext {
  realm: ActivityTrackerConfig['realm']
  surface: string
  owner?: string
  project?: string
  tenant?: string
  /** Headers naming a non-platform identity (a project user's run-session
   *  headers, a site visitor's bearer). Absent = the platform cookie. */
  headers?: () => Record<string, string>
}

export function startActivity(ctx: HostActivityContext): void {
  try {
    installActivityTracker({
      endpoint: `${APP_BASE}/api/activity/collect`,
      realm: ctx.realm,
      surface: ctx.surface,
      owner: ctx.owner || '',
      project: ctx.project || '',
      tenant: ctx.tenant || '',
      credentials: 'same-origin',
      // Builder screens are navigation-heavy; their clicks add nothing the
      // page views and API-call log do not already say.
      captureClicks: ctx.realm !== 'builder',
      headers: () => {
        try { return ctx.headers ? ctx.headers() : {} } catch { return {} }
      },
    })
  } catch (e) {
    console.warn('[activity] could not start', e)
  }
}
